import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { t } from "i18next";
import { MailIcon } from "lucide-react";
import { useState } from "react";
import { DialogReferralInvitation } from "./dialog-referral-invitation";

export const CardReferralInvitation = ({
  onSendSuccess,
}: {
  onSendSuccess: () => void;
}) => {
  const [isInviteDialogOpen, setIsInviteDialogOpen] = useState(false);

  return (
    <>
      <Card className="flex flex-col flex-1 justify-between">
        <CardHeader>
          <CardTitle>{t("referrals.invite.title")}</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col flex-1 justify-between">
          <div className="mb-4 text-sm text-muted-foreground">
            {t("referrals.invite.description")}
          </div>
          <Button type="button" onClick={() => setIsInviteDialogOpen(true)}>
            <MailIcon className="mr-2 w-4 h-4" />
            {t("referrals.invite.button")}
          </Button>
        </CardContent>
      </Card>

      <DialogReferralInvitation
        isOpen={isInviteDialogOpen}
        onClose={() => setIsInviteDialogOpen(false)}
        onSuccess={onSendSuccess}
      />
    </>
  );
};
